import {
  INITIAL_DATA_GET_REQUEST,
  INITIAL_DATA_GET_SUCCESS,
  INITIAL_DATA_GET_ERROR,
} from 'Redux/types/initialDataTypes';
import { EXTERNAL_FORM_DEFAULTS } from '@/features/externalForm/constants';
import { externalFormFromDto } from '@/features/externalForm/mappers';

const initialState = {
  user: {
    fullName: null,
    username: null,
    email: null,
    perfil: null,
    profileName: null,
    sedes: [],
    isSupportUser: false,
  },
  userAccess: {},
  aseguradoras: [],
  quotation_states: [],
  requestState: {
    isFeching: false,
    message: '',
    statusCode: null,
  },
  has_solicitudes_module: false,
  sedes: [],
  vehicle_data_provider_consult_origin: null,
  marcablanca:{
    logo_marca_blanca:null,
    logo:null,
    logo_icon:null,
    color_marca_blanca:null,
    color_marca_blanca_resaltado:null,
    tiene_marca_blanca:null,
    has_marca_blanca:null,
    title_marca_blanca:null,
    url_marca_blanca:null,
  },
  externalForm: EXTERNAL_FORM_DEFAULTS,
  whatsapp_is_logged: null,
};
const initialData = (state = initialState, actions) => {
  switch (actions.type) {
    case INITIAL_DATA_GET_REQUEST:
      return ({
        ...state,
        requestState: {
          ...initialState.requestState,
          isFeching: true,
        },
      });
    case INITIAL_DATA_GET_SUCCESS:
      return {
        ...state,
        has_solicitudes_module: actions.response.data.has_solicitudes_module,
        aseguradoras: [...actions.response.data.aseguradoras].sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })), // Ordena las aseguradoras por nombre
        quotation_states: actions.response.data.quotation_states,
        pusher: actions.response.data.pusher,
        user: {
          id: actions.response.data.user.id,
          fullName: [actions.response.data.user.first_name, actions.response.data.user.last_name].filter(Boolean).join(' '),
          username: actions.response.data.user.username,
          email: actions.response.data.user.email,
          perfil: actions.response.data.user.perfil,
          profileName: actions.response.data.user.profile_name,
          sedes: actions.response.data.user.sedes,
          isSupportUser: actions.response.data.user.is_support_user === true, // El campo solo está presente para usuarios de soporte
        },
        userAccess: actions.response.data.user_access,
        requestState: {
          isFeching: false,
        },
        sedes: [...(actions.response?.data?.sedes ?? [])].sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })), // Ordena las sedes por nombre
        vehicle_data_provider_consult_origin: actions.response?.data?.vehicle_data_provider_consult_origin || null,
        brand: {
          id: actions.response.data.brand.id,
          softseguros_id: actions.response.data.brand.softseguros_id,
          name: actions.response.data.brand.name,
        },
        marcablanca: actions.response?.data?.marcablanca,
        externalForm: externalFormFromDto(actions.response?.data?.external_form),
        whatsapp_is_logged: actions.response?.data?.whatsapp_is_logged,
      };
    case INITIAL_DATA_GET_ERROR:
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.data.message,
          statusCode: actions.response.status,
        },
      });
    default:
      return state;
  }
};

export default initialData;
